import _markdown from "./markdown";
var exports = {};
// super simple module for the most common nodejs use case.
exports.markdown = _markdown;
exports.parse = exports.markdown.toHTML;
export default exports;
export const markdown = exports.markdown,
      parse = exports.parse;